import { Routes } from '@angular/router';
import { NonAuthGuard } from './shared/guards/non-auth.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { userDataResolverResolver } from './shared/resolvers/UserDataResolver.resolver';
import { companyDataResolver } from './shared/resolvers/CompanyDataResolver.resolver';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./non-authenticated/non-authenticated.module').then(
        (m) => m.NonAuthenticatedModule,
      ),
    canActivate: [NonAuthGuard],
  },
  {
    path: 'dashboard',
    resolve: {
      userData: userDataResolverResolver,
      companyData: companyDataResolver,
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
    // resolve: { userData: userDataResolverResolver },
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
